export default __webpack_public_path__ + "static/media/powertower.2b0440e7.jpeg";